import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, Bot, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/apiClient";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const r = await api.post("/auth/login", { username, password });
      localStorage.setItem("token", r.data.token);
      localStorage.setItem("currentUser", JSON.stringify(r.data.user));
      toast.success("Berhasil masuk");
      navigate("/admin/dashboard");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6 grain relative overflow-hidden">
      <div className="absolute top-1/4 left-1/3 w-[400px] h-[400px] bg-[#2563EB] opacity-10 blur-[140px] rounded-full" />
      <div className="relative z-10 w-full max-w-md">
        <div className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-[#2563EB] flex items-center justify-center">
            <Bot size={22} className="text-white" />
          </div>
          <span className="font-heading font-extrabold text-xl tracking-tight text-slate-900">ContentChat<span className="text-[#2563EB]">AI</span></span>
        </div>
        <div className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-5 sm:p-8">
          <h1 className="font-heading text-2xl font-bold text-slate-900 mb-1">Panel Admin</h1>
          <p className="text-sm text-slate-600 mb-6">Masukkan username &amp; password untuk melanjutkan.</p>
          <form onSubmit={submit} className="space-y-4">
            <div className="flex items-center gap-2 bg-[#F1F5F9] border border-[#E2E8F0] rounded-xl px-3 focus-within:border-[#3B82F6] transition-colors">
              <User size={18} className="text-slate-500" />
              <input
                autoComplete="username"
                required
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username"
                data-testid="admin-login-username-input"
                className="bg-transparent min-w-0 flex-1 py-3 text-slate-900 outline-none text-sm"
                autoFocus
              />
            </div>
            <div className="flex items-center gap-2 bg-[#F1F5F9] border border-[#E2E8F0] rounded-xl px-3 focus-within:border-[#3B82F6] transition-colors">
              <Lock size={18} className="text-slate-500" />
              <input
                autoComplete="current-password"
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password admin"
                data-testid="admin-login-password-input"
                className="bg-transparent min-w-0 flex-1 py-3 text-slate-900 outline-none text-sm"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="text-xs text-[#E11D48] bg-[#F43F5E]/10 border border-[#F43F5E]/30 rounded-xl px-3 py-2.5">{error}</p>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit-button"
              className="w-full bg-[#2563EB] text-white font-semibold py-3 rounded-xl hover:bg-[#1D4ED8] transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? <Loader2 size={18} className="animate-spin" /> : "Masuk"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
